// extracted by mini-css-extract-plugin
module.exports = {"accordionItem":"FullModalAccordion_accordionItem__B8Hxi","accordionHeader":"FullModalAccordion_accordionHeader__RNkLK"};